import i18n from 'translations'

import AppMarketplaceContainer from './AppMarketplaceContainer'
import Detail from './Detail'

export const ROUTE_NAMES = {
  'APP_MARKETPLACE.BE_INSPIRED': 'APP_MARKETPLACE.BE_INSPIRED',
  'APP_MARKETPLACE.BE_PAID': 'APP_MARKETPLACE.BE_PAID',
  'APP_MARKETPLACE.BE_SEEN': 'APP_MARKETPLACE.BE_SEEN',
  'APP_MARKETPLACE.INDEX': 'APP_MARKETPLACE.INDEX',
  'APP_MARKETPLACE.NOODLE_NOW': 'APP_MARKETPLACE.NOODLE_NOW',
}

const AppMarketplaceRouting = {
  childRoutes: [
    {
      component: Detail,
      name: ROUTE_NAMES['APP_MARKETPLACE.BE_PAID'],
      path: 'be-paid',
      title: i18n.t('module:AppMarketplace:BePaid:appName'),
    },
    {
      component: Detail,
      name: ROUTE_NAMES['APP_MARKETPLACE.NOODLE_NOW'],
      path: 'noodle-now',
      title: i18n.t('module:AppMarketplace:NoodleNow:appName'),
    },
    {
      component: Detail,
      name: ROUTE_NAMES['APP_MARKETPLACE.BE_INSPIRED'],
      path: 'be-inspired',
      title: i18n.t('module:AppMarketplace:BeInspired:appName'),
    },
    {
      component: Detail,
      name: ROUTE_NAMES['APP_MARKETPLACE.BE_SEEN'],
      path: 'be-seen',
      title: i18n.t('module:AppMarketplace:BeSeen:appName'),
    },
  ],
  indexRoute: {
    component: AppMarketplaceContainer,
  },
  name: ROUTE_NAMES['APP_MARKETPLACE.INDEX'],
  path: 'app-marketplace',
  title: i18n.t('module:AppMarketplace:title'),
}

// @ts-ignore
AppMarketplaceRouting.ROUTE_NAMES = ROUTE_NAMES

export default AppMarketplaceRouting
